import React from 'react';
import Header from './Header';
import WalletAnalysis from './WalletAnalysis';
import CommentsSection from './CommentsSection';

const OraclePage = () => {
  return (
    <>
      <Header />
      <main className="main-content">
        <WalletAnalysis />
      </main>
      <CommentsSection />
      <footer className="footer">
        <p>© 2024 OrAi. All mysteries reserved.</p>
      </footer>
    </>
  );
};

export default OraclePage; 